import {useSystemStore} from "~/plugins/store/system";

export default defineNuxtRouteMiddleware(() => {
    const systemStore = useSystemStore();
    if (typeof window !== 'undefined') {
        systemStore.isIframe = window.self !== window.top;
    } else {
        systemStore.isIframe = false;
    }
});